"use client";
import React, { useEffect } from "react";
import { InteractionStatus } from "@azure/msal-browser";
import { getJWT, isJwtExpired } from "@/lib/auth";
import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import { useRouter } from "next/navigation";
import Image from "next/image";
import logo from "@/app/images/f_logo.svg";

const Home = () => {
    const isAuthenticated = useIsAuthenticated();
    const { inProgress, instance, accounts } = useMsal();
    const router = useRouter();

    useEffect(() => {
        if (inProgress === InteractionStatus.None && !isAuthenticated) {
            router.push("/signin/");
        } else if (isAuthenticated && accounts.length > 0) {
            getJWT(instance, accounts).then((jwt) => {
                const expired = isJwtExpired(jwt);
                if (expired) {
                    router.push("/signin/");
                } else {
                    router.push("/fai/");
                }
            });
        }
    }, [accounts, inProgress, instance, isAuthenticated, router]);

    return (
        <>
            <div className={`grid grid-cols-1 h-[90vh] justify-items-center items-center animate-slowfade`}>
                <div className={"animate-growshrink"}>
                    <Image src={logo} alt={"Fender F"} width={48} height={50} />
                </div>
            </div>
        </>
    );
};

export default Home;
